import { Google } from 'blaze-ui/icons'
import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { callToAction } from './shared/callToAction'
import { productName } from './shared/productName'
import { promotion } from './shared/promotion'
import { seoWords } from './shared/seoWords'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { language } from './shared/language'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.GoogleAds,
  icon: Google,
  steps: ['Context', 'Generate Ads'],
  title: TextChannels[ChannelType.GoogleAds].name,
  submitLabel: 'Generate Ads',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183786/Home%20Card%20Previews/jj66ae1z7ohrnjgdxade.png',
}

const fields = {
  topic: topic.meta({ label: 'What are the goals of your Google ad campaign?', generationType: meta.type }),
  product_name: productName.required(),
  seo_words: seoWords.meta({ label: 'What keywords should be included?' }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  include_images: includeImages,
  tone,
  language,
  promotion: promotion.meta({ collapsible: true }),
  callToAction: callToAction.meta({ collapsible: true }),
  source_material_ids: sourceMaterialIds,
}

export const GoogleAdsSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const GoogleAdsMultiStepSchema: MultiStepSchema<ChannelType.GoogleAds> = {
  steps: [
    GoogleAdsSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.GoogleAds,
    channel: ChannelType.GoogleAds,
  },
}
